@if (error(); as err) {
  <div
    class="fixed inset-0 z-100 flex items-center justify-center p-4"
    role="dialog"
    aria-modal="true"
    aria-labelledby="conservatore-dialog-title"
  >
    <button
      type="button"
      class="absolute inset-0 cursor-default bg-gray-900/60 backdrop-blur-sm"
      aria-label="Chiudi"
      (click)="close()"
    ></button>

    <div
      class="relative w-full max-w-xl overflow-hidden rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl dark:border-gray-700 dark:bg-gray-900"
    >
      <div class="flex items-start gap-4">
        <div
          class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400"
        >
          <svg
            class="h-6 w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <div class="flex-1">
          <h3
            id="conservatore-dialog-title"
            class="text-lg font-bold text-gray-900 dark:text-white"
          >
            Conservatore non accettato
          </h3>
          <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Non e possibile accettare questa sezione perche il conservatore associato non e ancora
            stato accettato. Accetta il conservatore prima di procedere.
          </p>
        </div>
      </div>

      <div class="mt-5 space-y-3">
        @if (err.current_conservatore) {
          <div
            class="rounded-xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-800"
          >
            <p
              class="mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
            >
              Conservatore corrente
            </p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">
              {{ err.current_conservatore.ragione_sociale }}
            </p>
            <div class="mt-2 flex items-center justify-between gap-3">
              <p class="text-xs text-gray-500 dark:text-gray-400">
                P.IVA: {{ err.current_conservatore.piva }}
              </p>
              <app-copy-to-clipboard-button
                [text]="err.current_conservatore.piva"
                ariaLabel="Copia la partita IVA del conservatore corrente"
                copiedAriaLabel="Partita IVA corrente copiata"
                title="Copia P.IVA"
                copiedTitle="Copiata"
              />
            </div>
          </div>
        }

        @if (err.previous_conservatore) {
          <div
            class="rounded-xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-800"
          >
            <p
              class="mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400"
            >
              Conservatore precedente
            </p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">
              {{ err.previous_conservatore.ragione_sociale }}
            </p>
            <div class="mt-2 flex items-center justify-between gap-3">
              <p class="text-xs text-gray-500 dark:text-gray-400">
                P.IVA: {{ err.previous_conservatore.piva }}
              </p>
              <app-copy-to-clipboard-button
                [text]="err.previous_conservatore.piva"
                ariaLabel="Copia la partita IVA del conservatore precedente"
                copiedAriaLabel="Partita IVA precedente copiata"
                title="Copia P.IVA"
                copiedTitle="Copiata"
              />
            </div>
          </div>
        }
      </div>

      <div class="mt-6 flex justify-end gap-3">
        <button
          type="button"
          (click)="close()"
          class="h-10 cursor-pointer rounded-xl border border-gray-200 px-4 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
        >
          Chiudi
        </button>
        <button
          type="button"
          (click)="goToConservatori()"
          class="h-10 cursor-pointer rounded-xl bg-blue-600 px-4 text-sm font-semibold text-white shadow-lg shadow-blue-500/20 transition-all hover:bg-blue-700 active:scale-95"
        >
          Vai ai Conservatori
        </button>
      </div>
    </div>
  </div>
}
